import React from 'react';
import ReactPlayer from 'react-player';

const VideoPlayer = (props) => (
	<ReactPlayer {...props} />
);
export default VideoPlayer;
